function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makeGridStyles = function makeGridStyles(_ref) {
  var breakpoints = _ref.breakpoints,
    primitives = _ref.primitives,
    tokens = _ref.tokens;
  // Use grid token "margin" values for container padding
  var containerBreakpointStyles = Object.fromEntries(breakpoints.keys.map(function (breakpoint) {
    return [breakpoints.up(breakpoints.values[breakpoint]), {
      // Subtract left padding of first grid item from left padding of container
      // for consistent padding on either side of the container
      paddingLeft: "calc(".concat(tokens.grid[breakpoint].margin, " - ").concat(tokens.grid[breakpoint].gutter, ")"),
      paddingRight: tokens.grid[breakpoint].margin
    }];
  }));
  // Programatically add scoped item spacing using the "gutter" values of the grid tokens
  var itemBreakpointStyles = Object.fromEntries(breakpoints.keys.map(function (breakpoint) {
    return [breakpoints.up(breakpoints.values[breakpoint]), _defineProperty({}, "& [class*='MuiGrid-item']", {
      paddingLeft: tokens.grid[breakpoint].gutter,
      paddingTop: tokens.grid[breakpoint].gutter
    })];
  }));
  return {
    MuiGrid: {
      styleOverrides: {
        root: _objectSpread({
          "&[class*='MuiGrid-container']": _objectSpread(_objectSpread({}, containerBreakpointStyles), {}, {
            maxWidth: primitives.grid["max-width"]
          })
        }, itemBreakpointStyles)
      }
    }
  };
};